const form = document.getElementById('get-in-touch-form');

form?.addEventListener('submit', async function (event) {
  event.preventDefault();
  const formData = new FormData(form);
  const { email, phone } = Object.fromEntries(formData);

  const formWrapper = document.querySelector('.get-in-touch-form-wrapper'),
    emailInput = document.getElementById('email'),
    phoneInput = document.getElementById('phone'),
    emailBlock = document.querySelector('.email-validation'),
    phoneBlock = document.querySelector('.phone-validation'),
    emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  // phonePattern =
  //   /^(?:([+]\d{1,4})[-.\s]?)?(?:[(](\d{1,3})[)][-.\s]?)?(\d{1,4})[-.\s]?(\d{1,4})[-.\s]?(\d{1,9})$/;

  const submitButton = event.target.querySelector('button[type="submit"]');

  if (!emailPattern.test(email)) {
    emailInput.focus();
    emailBlock.classList.add('error');
    return false;
  }

  // if (!phonePattern.test(phone)) {
  //   phoneInput.focus();
  //   phoneBlock.classList.add('error');
  //   return false;
  // }

  emailBlock.classList.remove('error');

  submitButton.setAttribute('disabled', true);
  submitButton.classList.add('is-loading');

  const data = await fetch(globalVars.ajaxUrl, {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .finally(() => {
      submitButton.removeAttribute('disabled');
    });

  submitButton.classList.remove('is-loading');

  formWrapper.innerHTML =
    '<p class="form-success">' + data.data.message + '</p>';
  form.reset();
});

document.querySelectorAll('.js-detail').forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();

    const value = button.dataset.value;
    const checkbox = document.querySelector(
      `.js-get-in-touch-options input[value="${value}"]`
    );
    checkbox.closest('form').scrollIntoView({
      behavior: 'smooth',
    });
    checkbox.click();
  });
});
